import "./__content.scss"; import "./__form.scss"; import "./__title.scss"; import "./current_term_module.scss"
import "./__content.coffee"; import "./__form.coffee"; import "./current_term_module.coffee"
